"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("util");
class UrbanjsToolsError {
}
exports.UrbanjsToolsError = UrbanjsToolsError;
// we can not extend built-in classes
// by `extends` syntax as we are using babel
util_1.inherits(UrbanjsToolsError, Error);
class NotFoundTool extends UrbanjsToolsError {
}
exports.NotFoundTool = NotFoundTool;
class InvalidUsage extends UrbanjsToolsError {
}
exports.InvalidUsage = InvalidUsage;
